const project = {
  gitHubUsername: 'harshbhandariv',
  repos: [
    'formmaker',
    'fourierchaos',
    'Blog-API',
    'characteristicEquation',
    'chromaticpolynomial',
    'harshbhandariv.github.io',
  ],
};

const about = {
  firstName: 'Harsh',
  lastName: 'Bhandari',
  aboutme:
    'I am working as a Solution Consultant at <a href="https://sahaj.ai">Sahaj Software</a>. I am passionate about creating practical solutions. I enjoy turning complex ideas into user-friendly code.',
  tags: ['Engineer', 'Web Developer', 'Tech Enthusiast'],
};

const contact = {
  email: 'harsh.bhandari.v@gmail.com',
  socials: {
    GitHub: 'https://github.com/harshbhandariv',
    LinkedIn: 'https://www.linkedin.com/in/harshbhandariv/',
    Twitter: 'https://twitter.com/harshbhandariv',
  },
  fewWords: 'Feel free to say Hi',
};

export { project, about, contact };
